import type { ChakraProps } from "@chakra-ui/react";

export const customClassNames: Record<string, ChakraProps["sx"]> = {
  ".white": {
    color: "white",
  },
  ".brandBlueFont": {
    color: "primary.500",
  },
  ".brandingDark": {
    color: "greyscale.500",
  },
  ".greyscale700": {
    color: "greyscale.700",
  },
  ".greyscale600": {
    color: "greyscale.600",
  },
  ".medium": {
    fontSize: "md",
  },
  ".font-size-medium": {
    fontSize: "md",
  },
  ".underline": {
    textDecoration: "underline",
  },
  ".display-inline": {
    display: "inline",
  },
  ".font-weight-medium": {
    fontWeight: "medium",
  },
  ".margin-bottom-0": {
    mb: 0,
  },
  ".margin-bottom-3": {
    mb: 3,
  },
  ".margin-bottom-5": {
    mb: 5,
  },
  ".margin-bottom-8": {
    mb: 8,
  },
  ".margin-top-6": {
    mt: 6,
  },
  ".display-block": {
    display: "block",
  },
  ".primary700": {
    color: "primary.700",
  },
  ".subheading": {
    color: "primary.500",
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    fontSize: "xs",
    fontWeight: "bold",
  },
};
